module.exports = __webpack_public_path__ + "static/media/icon-1.d34355aa.svg";